module.exports = __webpack_public_path__ + "img/xianglian.beacd498.png";